import { request } from './request'

/**
 * 获取专题信息
 * @param {String} specialCode - 专题编码
 * @param {String} templatePath - 当前页面路径
 * @returns {Promise<Object>} 专题配置信息
 */
export async function fetchSpecialInfo(specialCode, templatePath = '') {
  const res = await request.post('/api/special/getInfo', {
    specialCode,
    templatePath
  })
  return res.data || {}
}
